export default __webpack_public_path__ + "static/media/token-supply-large.3c0547f9.png";